import { render, staticRenderFns } from "./ResourceAgreementsDialog.html?vue&type=template&id=5b9a3702&external"
import script from "./ResourceAgreementsDialog.js?vue&type=script&lang=js&external"
export * from "./ResourceAgreementsDialog.js?vue&type=script&lang=js&external"
import style0 from "./ResourceAgreementsDialog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports